export const SelectedOfferOverlayMessages = {
  title: {
    id: 'Pages.PostSubmission.Approved.Offer.Selected',
    defaultMessage: 'Your offer',
    description: 'Selected offer',
  },
}
